import {
  GRADIENT_BACKGROUND_PAGE_CONFIG,
  KNOWLEDGE_EXTENDED_PAGE_CONFIG,
  PAGES_CONFIG,
  PAGE_THEMES,
  PAGE_THEME_BY_COHORT,
  PAGE_THEME_CONFIGS,
  PARENTING_QUIZ_V5_PAGE_CONFIG,
  PROGRESS_SECTIONS_BY_COHORT,
} from 'pages-config'

import { getAppConfigMap } from 'helpers/getAppConfigMap'

import { PageId } from 'page-constants'
import { Color, TEST_SEGMENTS } from 'root-constants'

import { useCohortInfo } from './useCohortInfo'
import { useExperimentalFeatures } from './useExperimentalFeatures'
import { useGetPageInfo } from './useGetPageInfo'

export function usePageConfig() {
  const {
    currentPageId,
    isFirstPage,
    isSkippableStep,
    isPostPaymentPage,
    isSubscriptionsPage,
    hasHeader,
  } = useGetPageInfo()
  const { cohortToUse } = useCohortInfo()
  const {
    ayah93SdQuizVariant,
    ayah115ParentingQuizVariant,
    ayah126KnowledgeExtendedVariant,
  } = useExperimentalFeatures()

  const { appConfig } = getAppConfigMap()

  const isSdQuizPage =
    ayah93SdQuizVariant === TEST_SEGMENTS.VARIANT_B &&
    !isPostPaymentPage &&
    !isSubscriptionsPage
  const pageTheme = PAGE_THEME_BY_COHORT[cohortToUse] ?? PAGE_THEMES.DEFAULT
  const isParentingQuizV5Variant =
    ayah115ParentingQuizVariant === TEST_SEGMENTS.VARIANT_C
  const isKnowledgeExtendedVariant =
    ayah126KnowledgeExtendedVariant === TEST_SEGMENTS.VARIANT_B
  const ownPageConfig = PAGES_CONFIG[currentPageId as PageId]

  const pageConfig = {
    isBackButtonDisabled: false,
    ...PAGE_THEME_CONFIGS[pageTheme],
    progressTrackColor: Color.WHITE,
    isHeaderOverlay: false,
    hasGlassHeader: false,
    hasBottomBarBackground: true,
    fillsViewport: false,
    headerTitle: appConfig.displayName,
    progressSections: PROGRESS_SECTIONS_BY_COHORT[cohortToUse],
    ...(isSdQuizPage && GRADIENT_BACKGROUND_PAGE_CONFIG),
    ...(isParentingQuizV5Variant && PARENTING_QUIZ_V5_PAGE_CONFIG),
    ...(isKnowledgeExtendedVariant && KNOWLEDGE_EXTENDED_PAGE_CONFIG),
    ...ownPageConfig,
  }

  const isHeaderOverlaidByVariant =
    pageConfig.isHeaderOverlay && !ownPageConfig?.isHeaderOverlay

  return {
    ...pageConfig,
    isBackButtonDisabled: pageConfig.isBackButtonDisabled || isFirstPage,
    hasHeaderOffset: hasHeader && isHeaderOverlaidByVariant,
    isFirstPage,
    isSkippableStep,
  }
}
